import * as CubeTree from '../cubeTree/index';
import FrontCubeData from '../frontCubeData/index';
import Utils from '../utils/util';
import { layerLink } from '../interaction/layerGroup/link';

function getLayerLayoutUpadteQueue(updateTaskQueue: UpdateTask[]): UpdateTask[] {
    let result: UpdateTask[] = [];
    let keys: string[] = ['xplaceType', 'xdirection'];

    updateTaskQueue.forEach((task: UpdateTask): void => {
        if (!CubeTree.isPartition(task.cubeId)) {
            return;
        }
        let grouped: number = FrontCubeData.getValue(task.cubeId, 'grouped');
        if (grouped != 1) {
            return;
        }

        let layoutTask: FreeObjMap = layerLayoutUpdateInfo(keys, task.updateData);
        if (Utils.isEmptyObj(layoutTask)) {
            return;

        }
        let link: LinkedListInstance|null = layerLink(task.cubeId);
        let layers: CubeId[] = link.valueList();
        let groupLayers: CubeId[] = layers.filter((layer: CubeId): boolean => {
            return layer !== task.cubeId;
        });

        groupLayers.forEach((layer: CubeId): void => {
            result.push({
                cubeId: layer,
                updateData: layoutTask
            });
        });
    });

    return result;
}

function layerLayoutUpdateInfo(keys: string[], updateData: FreeObjMap): FreeObjMap {
    let result: FreeObjMap = {};

    for (let i = 0; i < keys.length; i++) {
        if (Utils.hasKey(updateData, keys[i])) {
            result[keys[i]] = updateData[keys[i]];
        }
    }

    return result;
}

export {
    getLayerLayoutUpadteQueue
};
